export default __webpack_public_path__ + "_/react/conversations/FeaturePreview/assets/images/conversation-module.png";